module.exports = __webpack_public_path__ + "static/media/calendar-ok.85519abd.svg";